import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import BasicLayout from "../../components/Layouts/BasicLayout";
import { getSingleCustomer } from "../../store/actions/customer/customer.action";
import CustomerDetail from "./CustomerDetailTable";

export const CustomerDetails = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  useEffect(() => {
    dispatch(getSingleCustomer(id));
  }, [id, dispatch]);

  return (
    <BasicLayout>
      <CustomerDetail></CustomerDetail>
    </BasicLayout>
  );
};
